<template>
	<div class="mod-user">
		<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
			<el-form-item>
				<el-input v-model="dataForm.userName" placeholder="用户名" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<el-button @click="getDataList()">查询</el-button>
				<el-button v-if="isAuth('sys:user:save')" type="primary" @click="addOrUpdateHandle()">新增</el-button>
			</el-form-item>
		</el-form>
		<div class="hint">
			<div>已选中<span class="c-warning">{{dataListSelections.length}}</span>条</div>
			<div>
				<el-button size="mini" type="danger" icon="el-icon-delete" v-if="isAuth('sys:user:delete')" :disabled="dataListSelections.length<=0"
					@click="deleteHandle()">删除</el-button>
			</div>
		</div>
		<el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle"
			style="width: 100%;">
			<el-table-column type="selection" header-align="center" align="center" width="50">
			</el-table-column>
			<!-- <el-table-column prop="id" header-align="center" align="center" width="200" label="ID">
			</el-table-column> -->
			<el-table-column prop="username" header-align="center" align="center" label="序号" width="80">
				<template slot-scope="scope">
					 {{(pageIndex - 1) * pageSize + scope.$index + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="username" header-align="center" align="center" label="用户名">
			</el-table-column>
			<el-table-column prop="email" header-align="center" align="center" label="邮箱">
			</el-table-column>
			<el-table-column prop="mobile" header-align="center" align="center" label="手机号">
			</el-table-column>
			<el-table-column prop="status" header-align="center" align="center" label="状态">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.status === 0" size="small" type="danger">禁用</el-tag>
					<el-tag v-else size="small">正常</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="createDate" header-align="center" align="center" width="180" label="创建时间">
			</el-table-column>
			<el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
				<template slot-scope="scope">
					<el-button v-if="isAuth('sys:user:update')" type="text" size="small"
						@click="addOrUpdateHandle(scope.row.id)">修改</el-button>
					<el-button v-if="isAuth('sys:user:delete')" class="c-danger-imp" type="text" size="small"
						@click="deleteHandle(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
			:page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
			layout="total, sizes, prev, pager, next, jumper">
		</el-pagination>
		<!-- 弹窗, 新增 / 修改 -->
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
	</div>
</template>

<script>
	import AddOrUpdate from './user-add-or-update'
	export default {
		data() {
			return {
				dataForm: {
					userName: ''
				},
				dataList: [],
				pageIndex: 1,
				pageSize: 10,
				totalPage: 0,
				dataListLoading: false,
				dataListSelections: [],
				addOrUpdateVisible: false
			}
		},
		components: {
			AddOrUpdate
		},
		created() {
			this.getDataList()
		},
		methods: {
			// 获取数据列表
			async getDataList() {
				this.dataListLoading = true
				let param = {
					'page': this.pageIndex,
					'limit': this.pageSize,
					'username': this.dataForm.userName
				}
				let res = await this.$get('/platform-admin/user/page', param);
				if (res && res.code == 0) {
					this.dataList = res.data.list
					this.totalPage = res.data.total
				}
				this.dataListLoading = false
			},
			// 每页数
			sizeChangeHandle(val) {
				this.pageSize = val
				this.pageIndex = 1
				this.getDataList()
			},
			// 当前页
			currentChangeHandle(val) {
				this.pageIndex = val
				this.getDataList()
			},
			// 多选
			selectionChangeHandle(val) {
				this.dataListSelections = val
			},
			// 新增 / 修改
			addOrUpdateHandle(id) {
				this.addOrUpdateVisible = true
				this.$nextTick(() => {
					this.$refs.addOrUpdate.init(id)
				})
			},
			// 删除
			deleteHandle(id) {
				let ids = id ? [id] : this.dataListSelections.map(item => {
					return item.id
				})
				this.$confirm(`确定执行删除操作?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$del('/platform-admin/user',ids).then((res) => {
						if (res && res.code === 0) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getDataList()
								}
							})
						} else {
							this.$message.error(res.msg)
						}
					})
				}).catch(() => {})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.hint {
		height: 40px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #FFF4E3;
		border-radius: 5px;
		padding: 0 17px;
		margin-bottom: 15px;
	}
</style>
